<template>
  <ll-new-modal
    :open="open"
    :title="'图标选择'"
    :class="`icon-picker-modal-wrapper ${bem.b()}`"
    width="766px"
    :keyboard="false"
    :mask-closable="false"
    :is-show-footer-shadow="isShowContentBottomBox"
    footer-shadow-placement="outer"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div :class="bem.e('modal-content')">
      <div :class="bem.e('input-container')">
        <a-form-item name="h">
          <ll-input
            v-model:value="searchIconValue"
            :class="bem.e('input')"
            placeholder="搜索..."
          >
            <template #prefix>
              <ll-icon icon-name="icon-search" />
            </template>
          </ll-input>
        </a-form-item>
      </div>
      <div ref="scrollRef" :class="bem.e('list')">
        <a-space :size="[16, 16]" wrap :class="bem.e('space')">
          <a-button
            v-for="item in iconList"
            :key="item.icon_id"
            type="default"
            :class="[
              bem.e('button'),
              selectIcon === item.font_class ? bem.is('active') : '',
            ]"
            @click="handleSelectIcon(item)"
          >
            <template #icon>
              <ll-icon
                :icon-name="'icon-' + item.font_class"
                style="font-size: 28px"
              />
            </template>
          </a-button>
        </a-space>
      </div>
    </div>
  </ll-new-modal>
</template>
<script lang="ts" setup>
import { computed, ref, watch, watchEffect } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { iconPickerModalEmits, iconPickerModalProps } from '../config'

import { useScroll } from '@ll-plus/hooks'
import type { IconPickerItem } from '../config'

defineOptions({
  name: 'LlIconPickerModal',
})

const props = defineProps(iconPickerModalProps)
const emits = defineEmits(iconPickerModalEmits)

const { scrollPosition, isHasScrollBar, scrollRef } = useScroll()

const searchIconValue = ref('')
const selectIcon = ref('')
const iconList = ref<IconPickerItem[]>([])
const bem = createNamespace('icon-picker-modal')

// 是否显示内容区域底部的阴影div
const isShowContentBottomBox = computed(() => {
  return isHasScrollBar.value && scrollPosition.value !== 'bottom'
})

const handleOk = () => {
  emits('changeIconValue', selectIcon.value)
  emits('update:open', false)
}
const handleCancel = () => emits('update:open', false)

const handleSelectIcon = (icon: IconPickerItem) =>
  (selectIcon.value = icon?.font_class as string)

watch(
  () => props.open,
  (newVisible) => {
    // 清空查询值
    if (newVisible) searchIconValue.value = ''

    if (newVisible) {
      selectIcon.value = props.value
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => props.data,
  (newData) => {
    iconList.value = [...newData]
  },
  {
    immediate: true,
  }
)

watch(searchIconValue, () => {
  iconList.value = props.data.filter(
    (ele) => ~ele.font_class!.indexOf(searchIconValue.value)
  )
})

// 滚动条回到顶部
watchEffect(() => {
  if (props.open) {
    // 头部有步骤条回到顶部
    if (isHasScrollBar && scrollRef.value && !scrollRef.value.scrollTop) {
      scrollRef.value.scrollTop = 0
      scrollPosition.value = 'top'
    }
  }
})
</script>
